import { render, staticRenderFns } from "./Kr2RirekishoPreview.vue?vue&type=template&id=428a1675&"
import script from "./Kr2RirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./Kr2RirekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports